import { render, staticRenderFns } from "./texto.vue?vue&type=template&id=7bf20394"
import script from "./texto.vue?vue&type=script&lang=js"
export * from "./texto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports